import { ObservableArray, View } from "binder"
import { CreateWarehouseKeepingPartViewModel, KeepingPartProduct } from "./createWarehouseKeepingPart-viewModel"
import { warehouseLocationMultiSelectorViewModel } from "src/Warehouse/warehouseLocationManipulation/warehouseLocationManipulation-viewModel";

export class CreateWarehouseKeepingPartView extends View<CreateWarehouseKeepingPartViewModel>{
    GetViewUniqueId(): string {
        return "V-8BF63511-5D25-4AE5-8C97-35EE92312EF9"
    }
    loadHtml(): string {
        let element = require('./createWarehouseKeepingPart.html').default;
        let style = require('./createWarehouseKeepingPart.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseKeepingId(v: string) { this._warehouseKeepingId = v; } public get warehouseKeepingId(): string { return this._warehouseKeepingId;} private _warehouseKeepingId: string;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set fromProductCode(v: string) { this._fromProductCode = v; } public get fromProductCode(): string { return this._fromProductCode;} private _fromProductCode: string;
    public set toProductCode(v: string) { this._toProductCode = v; } public get toProductCode(): string { return this._toProductCode;} private _toProductCode: string;
    public set warehouseLocationSelector(v: warehouseLocationMultiSelectorViewModel) { this._warehouseLocationSelector = v; } public get warehouseLocationSelector(): warehouseLocationMultiSelectorViewModel { return this._warehouseLocationSelector;} private _warehouseLocationSelector: warehouseLocationMultiSelectorViewModel;
    public set searchInAll(v: boolean) { this._searchInAll = v; } public get searchInAll(): boolean { return this._searchInAll;} private _searchInAll: boolean;
    public set keepingPartProducts(v: ObservableArray<KeepingPartProduct>) { this._keepingPartProducts = v; } public get keepingPartProducts(): ObservableArray<KeepingPartProduct> { return this._keepingPartProducts;} private _keepingPartProducts: ObservableArray<KeepingPartProduct>;
    public set selectAll(v: boolean) { this._selectAll = v; } public get selectAll(): boolean { return this._selectAll;} private _selectAll: boolean;
    
    searchProduct() {
        this.dataContext.searchProduct();
    }

    createPart() {
        this.dataContext.createPart();
    }

    close() {
        this.dataContext.closePopup();
    }
}
